<!-- Copyright ©2026 Hitachi High-Tech Corporation All Rights Reserved. -->
<div class="group-stats-view-container">
  <div class="view-mode-toggle">
    <button 
      mat-button 
      [class]="(viewMode$ | async) === ViewMode.MOLECULE? 'nb-primary': 'nb-inactive'"
      class = "nb-primary-hover"
      (click)="setViewMode(ViewMode.MOLECULE)"
    >Molecule</button>
    <button 
      mat-button 
      [class]="(viewMode$ | async) === ViewMode.ASSEMBLY ? 'nb-primary': 'nb-inactive'"
      class = "nb-primary-hover"
      (click)="setViewMode(ViewMode.ASSEMBLY)"
    >Assembly</button>
    <button 
      mat-button 
      [class]="(viewMode$ | async) === ViewMode.SV ? 'nb-primary': 'nb-inactive'"
      class = "nb-primary-hover"
      (click)="setViewMode(ViewMode.SV)"
    >SV</button>
  </div>
</div>
<div class="tab-body">
  <app-hce-stats-view-molecule
    [class.active]="selected === ViewMode.MOLECULE"
    class="tab-panel"
    [analysis]="analysis"
  ></app-hce-stats-view-molecule>
  <app-hce-stats-view-assembly
    [class.active]="selected === ViewMode.ASSEMBLY"
    class="tab-panel"
    [analysis]="analysis"
    [refNameMap]="refNameMap"
    (cellFilterRequest)="onAssemblyStatsCellFilter($event)"
  ></app-hce-stats-view-assembly>
  <app-hce-stats-view-sv
    [class.active]="selected === ViewMode.SV"
    class="tab-panel"
    [analysis]="analysis"
    [sv]="sv"
    [refNameMap]="refNameMap"
    (cellFilterRequest)="onSvStatsCellFilter($event)"
  ></app-hce-stats-view-sv>
</div>
